import React, { FC } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { IconButton, Stack, styled } from '@mui/material';
/* Icons */
import SettingsIco from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
import { dictionaryState } from '../../../../../../../../shared/components/dictionary/states/dictionary.state.ts';
import { ITextPopup } from './popup/text.popup.tsx';
import { Popup } from '../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { SValue } from '../../../../../../configuration/components/tabs/invoice/dictionaries/quantityDiscountsDict/cells/descriptionDict.cell.tsx';

export const DescriptionTextBlockCell: FC<TDescriptionTextBlockCell> = ({
  value,
  row,
  id,
  popupStream,
}) => {
  const { t } = useTranslation();
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    dictionaryState.pub.selectRow(row);
    popupStream.emit('open', { id: String(id), title: row.description });
  };

  return (
    <SStack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
      <SValue>{value}</SValue>
      <IconButton
        className='button'
        disabled={row.invalid || String(id).includes('new')}
        title={t('settings.text_block')}
        onClick={handleClick}
        sx={{ p: '3.5px' }}
        size='small'
      >
        <SettingsIco />
      </IconButton>
    </SStack>
  );
};

const SStack = styled(Stack)({});

type TDescriptionTextBlockCell = GridRenderCellParams & {
  popupStream: Popup<ITextPopup>['stream'];
};
